import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

export function WhatsAppButton() {
  return (
    <motion.a
      href="https://wa.me/447852872088?text=Hi%2C%20I'd%20like%20to%20discuss%20a%20website%20project"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 block md:hidden"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: 'spring', stiffness: 260, damping: 20 }}
      aria-label="Chat on WhatsApp"
    >
      <div className="relative">
        {/* Pulse animation ring */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-25" />
        
        {/* Button */}
        <div className="relative flex items-center justify-center w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-lg shadow-green-500/30 transition-colors">
          <MessageCircle className="w-7 h-7 text-white fill-white" />
        </div>
      </div>
    </motion.a>
  );
}
